export default __webpack_public_path__ + "static/media/app-store-4.b13d0426.svg";